import React, { useState, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useMealplanning } from "../../hooks/useMealplanning";
import {
  Plus, Search, Star, Sparkles, Link as LinkIcon,
  Calendar, Utensils, ChevronRight, X
} from "lucide-react";


const MEAL_TYPES = ["Frühstück", "Mittagessen", "Abendessen", "Snack/Anderes"];
const MEAL_TYPE_BY_ID = {
  1: "Frühstück",
  2: "Mittagessen",
  3: "Abendessen",
  4: "Snack/Anderes",
};

const MealPlanEditDialog = ({
  formData,
  setShowAddModal,
  setFormData,
  handleSave,
  recipes = []
}) => {

  return (
    <div className="min-vh-100 bg-light p-4" style={{ fontFamily: "'Segoe UI', Roboto, sans-serif" }}>

      {/* --- ADD MODAL --- */}
      <div className="modal-backdrop d-flex align-items-center justify-content-center p-3" style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 2000 }}>
        <div className="bg-white rounded-4 shadow-lg w-100 animate-slide-up" style={{ maxWidth: '500px' }}>
          <div className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="fw-bold mb-0">Gericht planen</h5>
              <X className="cursor-pointer text-muted" onClick={() => setShowAddModal(false)} />
            </div>

            {/* Internal Recipe Selector */}
            <div className="mb-3">
              <label className="form-label small fw-bold text-uppercase text-muted">Checkify Rezept</label>
              <select
                className="form-select rounded-3 border-light bg-light p-2"
                value={formData.recipeId || ""}
                onChange={e => {
                  const rId = e.target.value ? Number(e.target.value) : null;
                  const recipe = recipes?.find(r => r.id === rId);
                  setFormData({
                    ...formData,
                    recipeId: rId,
                    notes: recipe ? recipe.title : formData.notes, // Auto-fill title if selecting, else keep existing
                    servings: recipe ? (recipe.servings || 2) : (formData.servings || 2),
                    externalRecipeUrl: recipe ? "" : formData.externalRecipeUrl // Clear external URL if internal
                  });
                }}
              >
                <option value="">-- Kein Rezept ausgewählt --</option>
                {recipes && recipes.map(r => (
                  <option key={r.id} value={r.id}>
                    {r.title}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label small fw-bold text-uppercase text-muted">Rezeptname / Notiz</label>
              <input
                className="form-control rounded-3 border-light bg-light p-2"
                value={formData.notes || ""}
                onChange={e => setFormData({ ...formData, notes: e.target.value })}
                placeholder="z.B. Spaghetti Carbonara"
              />
            </div>

            {!formData.recipeId && (
              <div className="mb-3">
                <label className="form-label small fw-bold text-uppercase text-muted">Externer Link (URL)</label>
                <input
                  className="form-control rounded-3 border-light bg-light p-2"
                  value={formData.externalRecipeUrl || ""}
                  onChange={e => setFormData({ ...formData, externalRecipeUrl: e.target.value })}
                  placeholder="https://www.chefkoch.de/..."
                />
              </div>
            )}

            <div className="row g-3 mb-4">
              <div className="col-6">
                <label className="form-label small fw-bold text-uppercase text-muted">Datum</label>
                <input type="date" className="form-control rounded-3 border-light bg-light p-2" value={formData.planDate || ""} onChange={e => setFormData({ ...formData, planDate: e.target.value })} />
              </div>
              <div className="col-6">
                <label className="form-label small fw-bold text-uppercase text-muted">Wann</label>
                <select
                  className="form-select rounded-3 border-light bg-light p-2"
                  /* 1. Access mealTimeCodeId directly from formData */
                  value={formData?.mealTimeCodeId ?? 4}
                  onChange={e => {
                    const newVal = Number(e.target.value);
                    setFormData({
                      ...formData,
                      /* 2. Update mealTimeCodeId directly on the object */
                      mealTimeCodeId: newVal
                    });
                  }}
                >
                  {Object.entries(MEAL_TYPE_BY_ID).map(([id, name]) => (
                    <option key={id} value={id}>
                      {name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label small fw-bold text-uppercase text-muted">Portionen</label>
              <div className="d-flex align-items-center bg-light rounded-3 p-1 border">
                <button
                  className="btn btn-sm btn-link text-dark text-decoration-none fw-bold px-3"
                  onClick={() => setFormData(prev => ({ ...prev, servings: Math.max(1, (prev.servings || 2) - 1) }))}
                >
                  -
                </button>
                <input
                  type="number"
                  className="form-control border-0 bg-transparent text-center fw-bold p-0 shadow-none mobile-nospin"
                  style={{ width: '50px' }}
                  value={formData.servings || 2}
                  onChange={e => setFormData({ ...formData, servings: Math.max(1, parseInt(e.target.value) || 1) })}
                />
                <button
                  className="btn btn-sm btn-link text-dark text-decoration-none fw-bold px-3"
                  onClick={() => setFormData(prev => ({ ...prev, servings: (prev.servings || 2) + 1 }))}
                >
                  +
                </button>
              </div>
            </div>

            <div className="d-flex gap-2">
              <button className="btn btn-light rounded-3 flex-grow-1 fw-bold" onClick={() => setShowAddModal(false)}>Abbrechen</button>
              <button className="btn btn-primary rounded-3 flex-grow-1 fw-bold" onClick={handleSave}>Speichern</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MealPlanEditDialog;